<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import TabBar from './components/TabBar.vue'
import ShopBar from './components/ShopBar.vue'
import VConsole from 'vconsole'

const vConsole = new VConsole();
const route = useRoute()
// 计算是否显示TabBar
const showTabBar = computed(() => {
  // 定义需要显示TabBar的路由路径
  const visibleRoutes = ['/workbench', '/customer', '/live','/myindex']
  // 检查当前路由路径是否在可见路由列表中
  return visibleRoutes.includes(route.path)
})
// 计算是否显示ShopBar
const showShopBar = computed(() => {
  // 定义需要显示ShopBar的路由路径
  const visibleRoutes = ['/store_cart', '/store_order', '/store_shop_list']
  // 检查当前路由路径是否在可见路由列表中
  return visibleRoutes.includes(route.path)
})
</script>

<template>
  <div class="app-container">
    <router-view />
    <TabBar v-if="showTabBar" />
    <ShopBar v-if="showShopBar" />
  </div>
</template>

<style>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
